/* eslint-env browser */

// This ternary is required for test coverage. There is no document.querySelector for test and
// gulp-istanbul overwrites require so we can't use proxyquire to stub it out
let store = {}
if (document.querySelector) {
  const appPropStore = document.querySelector('script#modelData')
  if (appPropStore) {
    store = JSON.parse(appPropStore.innerHTML)?.pageData?.appProps
  }
}

class AppProps {

  /**
   * Gets an AppProp value from the client store
   * @param {string} name
   * @param {*} defaultValue
   */
  static get(name, defaultValue) {
    if (typeof store[name] === 'undefined') {
      return defaultValue
    }
    return store[name]
  }

  static getAll() {
    if (!store) {
      return {}
    }

    return store
  }

  /**
   * Gets a feature toggle AppProp value from the client store
   * @param {string} name
   * @param {*} defaultValue
   */
  static getFeatureToggle(name, defaultValue) {
    if (store.featureToggles == null) { // Check if feature toggle json exists
      return defaultValue
    } else if (store.featureToggles[name] == null) { // Check if the actual feature toggle exists
      return defaultValue
    }

    return store.featureToggles[name]
  }
}

export default AppProps
